import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '“欢乐社区总动员”首届水上趣味篮球赛最佳人气战队投票通道';
const baseUrl = 'HLSQZDY0721';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'active',
      name: `${baseUrl}-active`,
      component: () => import('./pages/Active.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
